import React from 'react';

require('scss/loader_spinner.scss');

const LoaderSpinner = () => (
    <div className="loader-spinner">
        <div className="row">
            <i className="fa fa-refresh fa-spin fa-5x" />
        </div>
    </div>
);

export default LoaderSpinner;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/loader_spinner.js